<template>
  <div id="chgcode">
    <!-- 未登录 忘记密码 -->
    <div class="container">
      <!-- 重置密码 -->
      <div v-show="toggle" class="resetCode">
        <div class="vertical_center">
          <img src="~@/assets/icon/icon_lock.png" class="icon-lock" /><span class="title">
            重置密码</span>
        </div>
        <el-input v-model="email" placeholder="邮箱"></el-input>

        <el-input v-model="message_code" placeholder="邮件验证码" class="code"></el-input>

        <el-button type="info" v-show="messageCode" style="background:#409eff;width:114px;margin-left:25px;"
        @click.native="getRebackMessageCode()" round><span></span>获取验证码</el-button>

        <el-button type="info" v-show="!messageCode" style="background:#a6a9ad;width:140px;" round>(<span
        class="countDown">{{ count_down }}</span>s)后重新获取</el-button>
        
        <el-input v-model="new_pwd" placeholder="新密码" show-password></el-input>
        <el-input v-model="qr_pwd" placeholder="确认密码" show-password></el-input> 

        <el-button type="info" style="background:#409eff;width:100%;" round @click="save">修改</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { sendEmail,changPwd } from "@/services";
export default {
  data() {
    return {
      email:'',
      message_code:'',
      new_pwd:'',
      qr_pwd:'',
      
      account: "", //手机或邮箱号
      messageCode: true, // 短信验证码倒计时切换
      message_code: "",
      back_message_code: "123456", //后台返回的验证码
      count_down: 60, // 倒计时
      toggle: true, //切换
      fresh_code: "", //新密码
      fresh_code_verify: "", // 确认新密码
      case_flag: 0, // 1--手机 2--邮箱
      first_phone: "", // 接收短信验证码的手机号
      first_email: "", // 接收邮箱验证码的邮箱地址
      userID: "",
    };
  },
  methods: {
    // 获取短信验证码倒计时动画
    getMessageCode() {
      console.log("点击");
      this.messageCode = false;
      let time = 59;
      let t = setInterval(() => {
        this.count_down = time;
        time--;
        if (time < 0) {
          this.count_down = 60;
          clearInterval(t);
          this.messageCode = true;
        }
      }, 1000);
    },


    // 请求后台 发送验证码
    getRebackMessageCode() {
      let reg_email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g;
      // 邮箱注册
      if (!reg_email.test(this.email)) {
        this.$message.warning("请填写正确的邮箱地址!");
        return;
      }
      this.getMessageCode();
      sendEmail({email:this.email,name:'',type:0}).then(res=>{
        if(res.success){
          this.$message.success("验证码发送成功!");
        }else{
          this.$message.warning(res.message);
        }
      }).catch(err=>{
        this.$message.warning("发送验证码失败!");
      })
    },

    save(){

      let {email,message_code,new_pwd,qr_pwd} = this;
      let data = { userName:'',email:email,code:message_code,newPwd1:new_pwd,newPwd2:qr_pwd};
      let reg_email = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.]){1,2}[A-Za-z\d]{2,5}$/g;
      // 邮箱注册
      if (!reg_email.test(email)) {
        this.$message.warning("请填写正确的邮箱地址!");
        return;
      }
     
      if(!message_code){
        this.$message.warning('请输入邮箱验证码');
        return 
      }
      if(!new_pwd){
        this.$message.warning('请输入新密码');
        return 
      }
      if(!qr_pwd){
        this.$message.warning('请输入确认密码');
        return 
      }
      if(new_pwd!==qr_pwd){
        this.$message.warning('新密码和确认密码不一致');
        return 
      }
      
      changPwd(data).then(res=>{
        if(res.success){
          this.$message.success('修改成功');
          this.$router.push('/login');
          localStorage.clear();
          sessionStorage.clear();

        }else{  
          this.$message.warning(res.message);
        }
      })

    }
  },
};
</script>

<style scoped>
#chgcode {
  width: 100%;
  height: 100%;
  background: url(~@/assets/img/Vol_006_SE182.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
}

.container {
  position: absolute;
  width: 25%;
  height: 40%;
  margin: 0 auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  padding: 20px;
}

.vertical_center {
  text-align: center;
}

.title {
  font-size: 14px;
  font-weight: bold;
  font-family: "Times New Roman", Times, serif;
  vertical-align: 21px;
}

.icon-lock {
  vertical-align: 0px;
}

.code {
  width: 55%;
}

.container>>>.el-input__inner {
  border-radius: 20px;
}

.container .el-button+.el-button {
  margin-left: 0px;
}

.next {
  background: #1b2343;
  cursor: pointer;
  color: #ffffff;
  display: block;
  width: 100%;
  border: 0;
  margin-top: 10px;
}

.container>>>.el-input {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
